import {
  api_url,
  legendLabelsBoxHeightLine,
  configChartsColorPalettes,
  yRight,
  partSumpTrajectory,
  popupInformation,
  defaultDatalabelsAlign,
  defaultDatalabelsAnchor,
  defaultDatalabelsFontWeight,
  defaultTicksCustomValue,
} from "../../../utils";

const AccesPmrTc = {
  checked: false,
  titleSideBar: "Accesibilidad para PMR a la red de transporte público",
  titleIndicator: "SUMP Trajectory Content.charts.AccesPmrTc.title",
  popupInformation: {
    status: "false",
    text: popupInformation[partSumpTrajectory]["accesPmrTc"],
  },
  keyFigure: {
    typeUpdate: "geographical_area", // year or geographical_area
    label: "",
    url: "",
    separator: "",
    position: "",
  },
  charts: [
    {
      typeChart: "bar",
      typeLabels: "years", // years or geographical_areas
      multiYearGeographicalArea: true,
      singleYearGeographicalAreaType: "year", // year or geographical_area : MUST BE CONSISTENT WITH THE TYPE_LABEL ARGUMENT OF THE DATASET URL
      titleChart: "",
      titleDisplay: "true",
      legendDisplay: "true",
      legendCustom: "false",
      legendLabelsBoxHeight: legendLabelsBoxHeightLine,
      maintainAspectRatio: true,
      indexAxis: "x", // x or y
      heightChart: "340",
      widthChart: "400",
      scales: {
        x: {
          type: "category",
          display: true,
          stacked: false,
          titleDisplay: false,
          titleText: "",
          gridDisplay: false,
          min: null,
          beginAtZero: false,
          ticks: {
            display: true,
            value: defaultTicksCustomValue,
          },
        },
        y: {
          type: "linear",
          display: true,
          stacked: false,
          titleDisplay: true,
          titleText: "SUMP Trajectory Content.charts.AccesPmrTc.axis.titleY",
          gridDisplay: true,
          beginAtZero: true,
          max: 100,
          ticks: {
            display: true,
            value: {
              prefix: "",
              suffix: "",
            },
          },
        },
        yRight: yRight,
      },
      annotationsProperties: {
        annotation1: {
          type: "line",
          xMin: undefined,
          xMax: undefined,
          yMin: 50,
          yMax: 50,
          borderColor: "rgb(229, 158, 221)",
          borderDash: [7, 7],
          borderDashOffset: 0,
          borderWidth: 3,
        },
        annotation2: {
          type: "line",
          xMin: undefined,
          xMax: undefined,
          yMin: 75,
          yMax: 75,
          borderColor: "rgb(78, 149, 217)",
          borderDash: [7, 7],
          borderDashOffset: 0,
          borderWidth: 3,
        },
      },
      keyFigure: {
        typeUpdate: "geographical_area", // year or geographical_area
        label: "",
        url: "",
        separator: "",
        position: "",
      },
      datasets: [
        {
          type: "line",
          label:
            "SUMP Trajectory Content.charts.AccesPmrTc.legend.Valeur cible 2034",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=acces_pmr_tc&trend=projection&chart=acces_pmr_tc_valeur_cible_2034&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_target_value_2034_acces_pmr_tc"
            ].backgroundColor["0"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_target_value_2034_acces_pmr_tc"
            ].borderColor["0"],
          borderWidth: 4,
          borderDash: [7, 7],
          pointStyle: "circle",
          pointRadius: 0,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: 1,
          categoryPercentage: 1,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
        {
          type: "line",
          label:
            "SUMP Trajectory Content.charts.AccesPmrTc.legend.Valeur cible 2044",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=acces_pmr_tc&trend=projection&chart=acces_pmr_tc_valeur_cible_2044&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_target_value_2044_acces_pmr_tc"
            ].backgroundColor["0"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_target_value_2044_acces_pmr_tc"
            ].borderColor["0"],
          borderWidth: 4,
          borderDash: [7, 7],
          pointStyle: "circle",
          pointRadius: 0,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: 1,
          categoryPercentage: 1,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
        {
          type: "bar",
          label: "SUMP Trajectory Content.charts.AccesPmrTc.legend.Acces",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=acces_pmr_tc&trend=projection&chart=acces_pmr_tc&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_target_value_2024_acces_pmr_tc"
            ].backgroundColor["0"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_target_value_2024_acces_pmr_tc"
            ].borderColor["0"],
          borderWidth: 2,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 3,
          tooltipUnit: "",
          barPercentage: 0.8,
          categoryPercentage: 0.4,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
      ],
    },
  ],
};

export default AccesPmrTc;
